import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig'

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;

export async function handleRedirectPromiseLogin() {
    let response = await msalInstance.handleRedirectPromise().then((response) => {
        //console.log("Handling redirect promise")
        if (response != undefined) {
            //console.log("Setting active account")
            msalInstance.setActiveAccount(response?.account)
        }
        //console.log(response)
        return response;
    });
    //console.log(response)
    return response;
}